export default __webpack_public_path__ + "static/media/questIcon.20ec583f.svg";